import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export class HomeTax extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/dashboard")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="nk-content-body">
            <div class="nk-block-head nk-block-head-sm">
                <div class="nk-block-between">
                    <div class="nk-block-head-content">
                        <h3 class="nk-block-title page-title">داشبورد سامانه مودیان</h3>
                        <div class="nk-block-des text-soft">
                            <p>{this.state.data.global.user.fname} {this.state.data.global.user.lname} عزیز خوش آمدید</p>
                        </div>
                    </div>
                </div>
            </div>





            {/*<ul className="row g-gs preview-icon-svg">*/}
            {/*    <li className="col-lg-3 col-6 col-sm-4">*/}
            {/*        <NavLink to="/companies/" className="preview-icon-box card card-bordered bg-gray">*/}
            {/*            <div className="preview-icon-wrap">*/}
            {/*                <svg viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg">*/}
            {/*                    <path d="m40 8h12" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>*/}
            {/*                    <rect fill="#fff" height="72" rx="2" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" width="50" x="23.5" y="3"></rect>*/}
            {/*                    <path d="m26.5 13h44a0 0 0 0 1 0 0v58a2 2 0 0 1 -2 2h-40a2 2 0 0 1 -2-2v-58a0 0 0 0 1 0 0z" fill="#e3e7fe"></path>*/}
            {/*                    <rect fill="#fff" height="14" rx="2" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" width="48" x="34.5" y="65"></rect>*/}
            {/*                    <circle cx="23.5" cy="71" fill="#fff" r="16" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></circle>*/}
            {/*                    <circle cx="23.5" cy="71" fill="#e3e7fe" r="12"></circle>*/}
            {/*                    <path d="m18.44 70h10.12a1.45 1.45 0 0 1 1.44 1.44v5.09a1.45 1.45 0 0 1 -1.44 1.47h-10.12a1.45 1.45 0 0 1 -1.44-1.47v-5.09a1.45 1.45 0 0 1 1.44-1.44z" fill="#6576ff"></path>*/}
            {/*                    <path d="m20 70v-2.53a3.5 3.5 0 0 1 7 0v2.53" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>*/}
            {/*                    <circle cx="23.5" cy="73.23" fill="#fff" r="1.5"></circle>*/}
            {/*                    <path d="m22.5 74.23h2a0 0 0 0 1 0 0v1.24a.76.76 0 0 1 -.76.76h-.47a.76.76 0 0 1 -.76-.76v-1.24a0 0 0 0 1 -.01 0z" fill="#fff"></path>*/}
            {/*                    <g fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">*/}
            {/*                        <path d="m48.5 69.5v5"></path>*/}
            {/*                        <path d="m50.5 70.79-4 2.52"></path>*/}
            {/*                        <path d="m50.5 73.31-4-2.52"></path>*/}
            {/*                        <path d="m57.17 69.5v5"></path>*/}
            {/*                        <path d="m59.17 70.79-4 2.52"></path>*/}
            {/*                        <path d="m59.17 73.31-4-2.52"></path>*/}
            {/*                        <path d="m65.83 69.5v5"></path>*/}
            {/*                        <path d="m67.83 70.79-4 2.52"></path>*/}
            {/*                        <path d="m67.83 73.31-4-2.52"></path>*/}
            {/*                        <path d="m74.5 69.5v5"></path>*/}
            {/*                        <path d="m76.5 70.79-4 2.52"></path>*/}
            {/*                        <path d="m76.5 73.31-4-2.52"></path>*/}
            {/*                    </g>*/}
            {/*                    <path d="m30.5 36h34v5h-34z" fill="#fff"></path>*/}
            {/*                    <path d="m30.5 43.75h34v5h-34z" fill="#fff"></path>*/}
            {/*                    <path d="m30.5 50.5h34v7h-34z" fill="#6576ff"></path>*/}
            {/*                    <path d="m49.5 52.5-2.75 3-1.25-1.36" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"></path>*/}
            {/*                    <circle cx="48.5" cy="23.5" fill="#c4cefe" r="7.5"></circle>*/}
            {/*                </svg>*/}
            {/*            </div>*/}
            {/*            <span className="preview-icon-name text-light">{this.state.data.company_count} مودی ثبت شده</span>*/}
            {/*        </NavLink>*/}
            {/*    </li>*/}
            {/*    <li className="col-lg-3 col-6 col-sm-4">*/}
            {/*        <NavLink to="/persons/" className="preview-icon-box card card-bordered bg-gray">*/}
            {/*            <div className="preview-icon-wrap">*/}
            {/*                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">*/}
            {/*                    <rect x="5" y="7" width="60" height="56" rx="7" ry="7" fill="#e3e7fe" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <rect x="25" y="27" width="60" height="56" rx="7" ry="7" fill="#e3e7fe" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <rect x="15" y="17" width="60" height="56" rx="7" ry="7" fill="#fff" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="15" y1="29" x2="75" y2="29" fill="none" stroke="#6576ff" stroke-miterlimit="10" stroke-width="2" />*/}
            {/*                    <circle cx="53" cy="23" r="2" fill="#c4cefe" />*/}
            {/*                    <circle cx="60" cy="23" r="2" fill="#c4cefe" />*/}
            {/*                    <circle cx="67" cy="23" r="2" fill="#c4cefe" />*/}
            {/*                    <rect x="22" y="39" width="20" height="20" rx="2" ry="2" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <circle cx="32" cy="45.81" r="2" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <path d="M29,54.31a3,3,0,0,1,6,0" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="49" y1="40" x2="69" y2="40" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="49" y1="51" x2="69" y2="51" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="49" y1="57" x2="59" y2="57" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="64" y1="57" x2="66" y2="57" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="49" y1="46" x2="59" y2="46" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="64" y1="46" x2="66" y2="46" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                </svg>*/}
            {/*            </div>*/}
            {/*            <span className="preview-icon-name text-light">{this.state.data.customer_count} شخص/خریدار ثبت شده</span>*/}
            {/*        </NavLink>*/}
            {/*    </li>*/}
            {/*    <li className="col-lg-3 col-6 col-sm-4">*/}
            {/*        <NavLink to="/stuffs/" className="preview-icon-box card card-bordered bg-gray">*/}
            {/*            <div className="preview-icon-wrap">*/}
            {/*                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">*/}
            {/*                    <rect x="44" y="24" width="41" height="43" transform="translate(129 91) rotate(-180)" fill="#fff" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <path d="M71,37V33.6A1.6,1.6,0,0,0,69.4,32H54.6A1.6,1.6,0,0,0,53,33.6V48.39A1.61,1.61,0,0,0,54.61,50H69.4A1.6,1.6,0,0,0,71,48.4V37Z" fill="#eff1ff" />*/}
            {/*                    <line x1="60" y1="42" x2="60" y2="45" fill="none" stroke="#6576ff" stroke-width="1.5" />*/}
            {/*                    <line x1="58" y1="46" x2="56" y2="46" fill="none" stroke="#6576ff" stroke-width="1.5" />*/}
            {/*                    <rect x="64" y="35" width="4" height="4" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />*/}
            {/*                    <rect x="56" y="35" width="4" height="4" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />*/}
            {/*                    <rect x="64" y="42" width="4" height="4" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />*/}
            {/*                    <polyline points="58 42 56 42 56 44" fill="none" stroke="#6576ff" stroke-width="1.5" />*/}
            {/*                    <path d="M48,53H78a0,0,0,0,1,0,0v9a0,0,0,0,1,0,0H48a2,2,0,0,1-2-2V55a2,2,0,0,1,2-2Z" transform="translate(124 115) rotate(-180)" fill="#e3e7fe" />*/}
            {/*                    <circle cx="70" cy="28" r="0.5" fill="none" stroke="#33d895" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <circle cx="75" cy="28" r="0.5" fill="none" stroke="#f4bd0e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <circle cx="80" cy="28" r="0.5" fill="none" stroke="#eb6459" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <rect x="5" y="9" width="40" height="72" rx="3" ry="3" fill="#e3e7fe" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <rect x="9" y="22" width="32" height="43" fill="#fff" />*/}
            {/*                    <polyline points="31 34 35 34 35 38" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <polyline points="19 54 15 54 15 50" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <polyline points="15 38 15 34 19 34" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <polyline points="35 50 35 54 31 54" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="25" y1="41" x2="25" y2="47" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="22" y1="44" x2="28" y2="44" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <circle cx="25" cy="74" r="3" fill="none" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="23" y1="15" x2="28" y2="15" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                </svg>*/}
            {/*            </div>*/}
            {/*            <span className="preview-icon-name text-light">{this.state.data.stuff_count} کالا/خدمت ثبت شده</span>*/}
            {/*        </NavLink>*/}
            {/*    </li>*/}
            {/*    <li className="col-lg-3 col-6 col-sm-4">*/}
            {/*        <NavLink to="/invoices/" className="preview-icon-box card card-bordered bg-gray">*/}
            {/*            <div className="preview-icon-wrap">*/}
            {/*                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">*/}
            {/*                    <rect x="12" y="5" width="55" height="68" rx="6" ry="6" fill="#e3e7fe" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <path d="M78,15.8l-5.72,6.33L66.7,16l-5.33,5.91-5.82-6.46L49.67,22,44.13,15.8l-5.49,6.09L33,15.62,27.27,22l-6.16-6.83L21,15V79c0,3.33,2.43,6,5.43,6H72.57c3,0,5.43-2.69,5.43-6V15.76S77.94,15.79,78,15.8Z" fill="#fff" stroke="#6576ff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <circle cx="49.5" cy="35.5" r="2.5" fill="#c4cefe" stroke="#c4cefe" stroke-miterlimit="10" stroke-width="2" />*/}
            {/*                    <line x1="71" y1="50" x2="28" y2="49.86" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="71" y1="56" x2="28" y2="55.86" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="71" y1="61" x2="28" y2="60.86" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="28" y1="45" x2="38" y2="45" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="61" y1="45" x2="71" y2="45" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="28" y1="76" x2="41" y2="76" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="61" y1="76" x2="69" y2="76" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                    <line x1="59" y1="66" x2="69" y2="66" fill="none" stroke="#c4cefe" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />*/}
            {/*                </svg>*/}
            {/*            </div>*/}
            {/*            <span className="preview-icon-name text-light">{this.state.data.invoice_count} صورتحساب ثبت شده</span>*/}
            {/*        </NavLink>*/}
            {/*    </li>*/}
            {/*</ul>*/}
            {/*<br/>*/}
            <div className="nk-block">

                <div className="row g-gs">
                    <div class="col-md-3">
                        <div class="card card-bordered card-full bg-secondary">
                            <div class="card-inner">
                                <div class="card-title-group align-start mb-0">
                                    <div class="card-title">
                                        <h6 class="subtitle text-light">فروش</h6>
                                    </div>
                                    <div class="card-tools">
                                        <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="right" aria-label="فروش" data-bs-original-title="فروش"></em>
                                    </div>
                                </div>
                                <div class="card-amount">
                                    <span class="amount text-light">
                                        {this.state.data.sumSale}
                                        <span class="currency currency-usd text-light">ریال</span>
                                    </span>
                                </div>
                                <div class="invest-data">
                                    <div class="invest-data-amount g-2">
                                        <div class="invest-data-history">
                                            <div class="title text-light">این ماه</div>
                                            <div class="amount text-light">
                                                {this.state.data.sumSaleMonths}
                                                <span class="currency currency-usd text-light">ریال</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="invest-data-ck">
                                        <canvas class="iv-data-chart" id="totalDeposit" width="136" height="48" ></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="card card-bordered card-full bg-gray">
                            <div class="card-inner">
                                <div class="card-title-group align-start mb-0">
                                    <div class="card-title">
                                        <h6 class="subtitle text-light">فروش ارز</h6>
                                    </div>
                                    <div class="card-tools">
                                        <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="right" aria-label="فروش ارز" data-bs-original-title="فروش ارز"></em>
                                    </div>
                                </div>
                                <div class="card-amount">
                                    <span class="amount text-light">
                                        {this.state.data.sumDolar}
                                        <span class="currency currency-usd text-light">ریال</span>
                                    </span>
                                </div>
                                <div class="invest-data">
                                    <div class="invest-data-amount g-2">
                                        <div class="invest-data-history">
                                            <div class="title text-light">این ماه</div>
                                            <div class="amount text-light">
                                                {this.state.data.sumDolarMonths}
                                                <span class="currency currency-usd text-light">ریال</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="invest-data-ck">
                                        <canvas class="iv-data-chart" id="totalDeposit" width="136" height="48" ></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="card card-bordered card-full bg-info">
                            <div class="card-inner">
                                <div class="card-title-group align-start mb-0">
                                    <div class="card-title">
                                        <h6 class="subtitle text-light">طلا جواهر و پلاتین</h6>
                                    </div>
                                    <div class="card-tools">
                                        <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="right" aria-label="طلاجواهر و پلاتین" data-bs-original-title="طلا جواهر و پلاتین"></em>
                                    </div>
                                </div>
                                <div class="card-amount">
                                    <span class="amount text-light">
                                        {this.state.data.sumGold}
                                        <span class="currency currency-usd text-light">ریال</span>
                                    </span>
                                </div>
                                <div class="invest-data">
                                    <div class="invest-data-amount g-2">
                                        <div class="invest-data-history">
                                            <div class="title text-light">این ماه</div>
                                            <div class="amount text-light">
                                                {this.state.data.sumGoldMonths}
                                                <span class="currency currency-usd text-light">ریال</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="invest-data-ck">
                                        <canvas class="iv-data-chart" id="totalDeposit" width="136" height="48" ></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="card card-bordered card-full bg-blue">
                            <div class="card-inner">
                                <div class="card-title-group align-start mb-0">
                                    <div class="card-title">
                                        <h6 class="subtitle text-light">پیمانکاری</h6>
                                    </div>
                                    <div class="card-tools">
                                        <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="right" aria-label="پیمانکاری" data-bs-original-title="پیمانکاری"></em>
                                    </div>
                                </div>
                                <div class="card-amount">
                                    <span class="amount text-light">
                                        {this.state.data.sumPey}
                                        <span class="currency currency-usd text-light">ریال</span>
                                    </span>
                                </div>
                                <div class="invest-data">
                                    <div class="invest-data-amount g-2">
                                        <div class="invest-data-history">
                                            <div class="title text-light">این ماه</div>
                                            <div class="amount text-light">
                                                {this.state.data.sumPeyMonths}
                                                <span class="currency currency-usd text-light">ریال</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="invest-data-ck">
                                        <canvas class="iv-data-chart" id="totalDeposit" width="136" height="48" ></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="card card-bordered card-full bg-primary">
                            <div class="card-inner">
                                <div class="card-title-group align-start mb-0">
                                    <div class="card-title text-light">
                                        <h6 class="subtitle text-light">قبوض خدماتی</h6>
                                    </div>
                                    <div class="card-tools">
                                        <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="right" aria-label="قبوض خدماتی" data-bs-original-title="قبوض خدماتی"></em>
                                    </div>
                                </div>
                                <div class="card-amount">
                                    <span class="amount text-light">
                                        {this.state.data.sumKh}
                                        <span class="currency currency-usd text-light">ریال</span>
                                    </span>
                                </div>
                                <div class="invest-data">
                                    <div class="invest-data-amount g-2">
                                        <div class="invest-data-history">
                                            <div class="title text-light">این ماه</div>
                                            <div class="amount text-light">
                                                {this.state.data.sumKhMonths}
                                                <span class="currency currency-usd text-light">ریال</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="invest-data-ck">
                                        <canvas class="iv-data-chart" id="totalDeposit" width="136" height="48" ></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="card card-bordered card-full bg-indigo">
                            <div class="card-inner">
                                <div class="card-title-group align-start mb-0">
                                    <div class="card-title">
                                        <h6 class="subtitle text-light">بلیط هواپیما</h6>
                                    </div>
                                    <div class="card-tools">
                                        <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="right" aria-label="طلاجواهر و پلاتین" data-bs-original-title="طلا جواهر و پلاتین"></em>
                                    </div>
                                </div>
                                <div class="card-amount">
                                    <span class="amount text-light">
                                        {this.state.data.sumTicket}
                                        <span class="currency currency-usd text-light">ریال</span>
                                    </span>
                                </div>
                                <div class="invest-data">
                                    <div class="invest-data-amount g-2">
                                        <div class="invest-data-history">
                                            <div class="title text-light">این ماه</div>
                                            <div class="amount text-light">
                                                {this.state.data.sumTicketMonths}
                                                <span class="currency currency-usd text-light">ریال</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="invest-data-ck">
                                        <canvas class="iv-data-chart" id="totalDeposit" width="136" height="48" ></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-3">
                        <div class="card card-bordered card-full bg-dark">
                            <div class="card-inner">
                                <div class="card-title-group align-start mb-0">
                                    <div class="card-title">
                                        <h6 class="subtitle text-light">صادرات</h6>
                                    </div>
                                    <div class="card-tools">
                                        <em class="card-hint icon ni ni-help-fill" data-bs-toggle="tooltip" data-bs-placement="right" aria-label="طلاجواهر و پلاتین" data-bs-original-title="طلا جواهر و پلاتین"></em>
                                    </div>
                                </div>
                                <div class="card-amount">
                                    <span class="amount text-light">
                                        {this.state.data.sumTran}
                                        <span class="currency currency-usd text-light">ریال</span>
                                    </span>
                                </div>
                                <div class="invest-data">
                                    <div class="invest-data-amount g-2">
                                        <div class="invest-data-history">
                                            <div class="title text-light">این ماه</div>
                                            <div class="amount text-light">
                                                {this.state.data.sumTranMonths}
                                                <span class="currency currency-usd text-light">ریال</span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="invest-data-ck">
                                        <canvas class="iv-data-chart" id="totalDeposit" width="136" height="48" ></canvas>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <br />
                <div className="row g-gs">
                    <div class="col-lg-12">
                        <div class="card card-bordered h-100">
                            <div class="card-inner-group">
                                <div class="card-inner card-inner-md">
                                    <div class="card-title-group">
                                        <div class="card-title">
                                            <h5 class="title">اطلاعات ثبت شده</h5>
                                        </div>
                                        <div class="card-tools me-n1">

                                        </div>
                                    </div>
                                </div>
                                <div class="card-inner">
                                    <div class="nk-wg-action">
                                        <div class="nk-wg-action-content">
                                            <em class="icon ni ni-cc-alt-fill"></em>
                                            <div class="title">
                                                {this.state.data.company_count} مودی ثبت شده
                                            </div>
                                        </div>
                                        <NavLink to="/companies/" class="btn btn-icon btn-trigger me-n2"><em class="icon ni ni-forward-ios"></em></NavLink>
                                    </div>
                                </div>
                                <div class="card-inner">
                                    <div class="nk-wg-action">
                                        <div class="nk-wg-action-content">
                                            <em class="icon ni ni-help-fill"></em>
                                            <div class="title">{this.state.data.customer_count} شخص/خریدار ثبت شده</div>
                                        </div>
                                        <NavLink to="/persons/" class="btn btn-icon btn-trigger me-n2"><em class="icon ni ni-forward-ios"></em></NavLink>
                                    </div>
                                </div>
                                <div class="card-inner">
                                    <div class="nk-wg-action">
                                        <div class="nk-wg-action-content">
                                            <em class="icon ni ni-wallet-fill"></em>
                                            <div class="title">{this.state.data.stuff_count} کالا/خدمت ثبت شده</div>
                                        </div>
                                        <NavLink to="/stuffs/" class="btn btn-icon btn-trigger me-n2"><em class="icon ni ni-forward-ios"></em></NavLink>
                                    </div>
                                </div>
                                <div class="card-inner">
                                    <div class="nk-wg-action">
                                        <div class="nk-wg-action-content">
                                            <em class="icon ni ni-wallet-fill"></em>
                                            <div class="title">{this.state.data.invoice_count} صورتحساب ثبت شده</div>
                                        </div>
                                        <NavLink to="/invoices/" class="btn btn-icon btn-trigger me-n2"><em class="icon ni ni-forward-ios"></em></NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}